import { Component, Input } from '@angular/core';
import {
    AirspaceAuthorisationDto,
    SimpleAirspaceJurisdictionDto,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import FileSaver from 'file-saver';
import { Subject, takeUntil } from 'rxjs';
import {
    airspaceAuthorisationTypesRequiringCurrentUserAsRpic,
    airspaceAuthorisationsRequiringDataManagementDisplayLabels
} from '../authorisation/helpers';
import { AccountAirspaceDataService } from './account-airspace-data.service';

const airspaceAuthorisationsSpelling = {
    ['USA']: 'Authorizations'
};

@Component({
    selector: 'account-airspace-data',
    templateUrl: './account-airspace-data.component.html',
    providers: [AccountAirspaceDataService]
})
export class AccountAirspaceDataComponent {
    @Input() jurisdiction: SimpleAirspaceJurisdictionDto;
    disclaimer: string;
    authorisationType: AirspaceAuthorisationDto.AuthorisationType;

    working = false;
    private workTracker = new WorkTracker();
    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private accountAirspaceDataService: AccountAirspaceDataService
    ) {
        this.workTracker.observable
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(working => {
                this.working = working;
            });
    }

    ngOnInit() {
        this.disclaimer = `This download contains the operational information for your ${
            airspaceAuthorisationsSpelling[
                this.jurisdiction.identifier
            ]?.toLowerCase() ?? 'authorisations'
        }. For a full export please contact <a href="mailto: support@flyfreely.io">support@flyfreely.io</a>`;

        this.authorisationType =
            airspaceAuthorisationTypesRequiringCurrentUserAsRpic[
                this.jurisdiction.identifier
            ];
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    downloadAllUsersAuthorisations() {
        this.accountAirspaceDataService
            .downloadAllUsersAuthorisations(
                this.jurisdiction.airspaceCheckerUrl,
                this.authorisationType
            )
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(authorisations => {
                FileSaver.saveAs(
                    authorisations,
                    `${
                        airspaceAuthorisationsRequiringDataManagementDisplayLabels[
                            this.jurisdiction.identifier
                        ]
                    }_${
                        airspaceAuthorisationsSpelling[
                            this.jurisdiction.identifier
                        ] ?? 'Authorisations'
                    }.csv`
                );
            })
            .add(this.workTracker.createTracker());
    }
}
